import { render } from "./ViewMyChildrenClassrecodDialog.vue?vue&type=template&id=5ff74769"
import script from "./ViewMyChildrenClassrecodDialog.vue?vue&type=script&lang=js"
export * from "./ViewMyChildrenClassrecodDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__